import isPageEditor from 'GlobalsScript/is-page-editor';
(function (window, document) {
     
    document.addEventListener('DOMContentLoaded', function () {

        var timelineSpots = document.querySelectorAll(".js-timeline");

        
        if(isPageEditor()){
            console.log("is sitecore editor");
            document.querySelector("main").classList.add("sc-editor")
        }else{

            if (timelineSpots.length>0) {
                var timeout;
                var VISIBLE_CLASS = "visible", 
                    HIDDEN_CLASS = "not-visible", 
                    ACTIVE_CLASS = "active",
                    CHECKBOX_CLASS = ".tabs__selector",
                    TAB_NAV_CLASS = "tabs--nav",
                    TABS_INIT_CLASS = "tabs--nav--init",
                    TABS_END_CLASS = "tabs--nav--end",
                    INNER_WRAPPER_CLASS = ".tabs__tab-inner-wrapper",
                    DT_LABELS_CLASS = ".tabs__tab-wrapper .tabs__tab-label",
                    M_LABELS_CLASS = ".tabs__tab-label--mobile",
                    ARROW_WIDTH = 30;

                function addStateClass(spot, stateClass) {
                    spot.classList.remove(TABS_INIT_CLASS, TABS_END_CLASS);
                    spot.classList.add(stateClass);
                }

                function scrollable(thisSpot) {
                    var labelWidth = setLabelsWidth(thisSpot);
                    
                    if (labelWidth > thisSpot.offsetWidth) {
                        thisSpot.classList.add(TAB_NAV_CLASS);
                    } else {
                        thisSpot.classList.remove(
                            TAB_NAV_CLASS, 
                            TABS_INIT_CLASS,
                            TABS_END_CLASS);
                    }
                    resetsetVisibility(thisSpot);
                }

                function  setLabelsWidth(spot){
                    var labels = spot.querySelectorAll(DT_LABELS_CLASS);
                    var labelWidth = 0;
                    for (var i = 0; i < labels.length; i++) {
                        var lWidth = labels[i].offsetWidth;
                        labelWidth += lWidth;
                    }
                    return labelWidth;
                }

                function resetsetVisibility(thisSpot,next){
                    
                    var tabs = thisSpot.querySelectorAll(DT_LABELS_CLASS),
                        inner = thisSpot.querySelector(INNER_WRAPPER_CLASS),
                        lastTab = tabs[tabs.length-1],
                        firstTab = tabs[0];

                    setTimeout(function(){
                        for (var t = 0; t < tabs.length; t++) { 
                            var el =  tabs[t];
                            el.classList.remove(VISIBLE_CLASS,HIDDEN_CLASS);
                            var visibility = isInViewportH(el,inner) ? VISIBLE_CLASS : HIDDEN_CLASS;
                            el.classList.add(visibility);
                        }

                        firstTab.classList.contains(VISIBLE_CLASS) ? thisSpot.classList.add(TABS_INIT_CLASS) : thisSpot.classList.remove(TABS_INIT_CLASS);
                        lastTab.classList.contains(VISIBLE_CLASS) ? thisSpot.classList.add(TABS_END_CLASS) : thisSpot.classList.remove(TABS_END_CLASS);
                        
                        
                        if (next && next === tabs[tabs.length - 1]) {
                            addStateClass(thisSpot, TABS_END_CLASS);
                        }
                        
                        
                    },300);
                    
                }

                function isInViewportH(elem,inner) {
                    var bounding = elem.getBoundingClientRect(),
                    container = inner.getBoundingClientRect();
                    
                    return (
                        bounding.left >= container.left && bounding.right <= container.right
                    );
                };

                function stickyTabs(spot){
                
                    var tabwrapper = spot.querySelector(".tabs__tab-wrapper"),
                        bottomNav =spot.querySelector(".tab__bottom-nav"),
                        tabwrapperHeight = tabwrapper.offsetHeight,
                        bottomNavHeight = bottomNav.offsetHeight,
                        endSticky = (tabwrapperHeight + bottomNavHeight);

                    var bounding = spot.getBoundingClientRect();
                    var isSticky = bounding.top < 0 && bounding.bottom > endSticky,
                        isStuck = bounding.top < 0 && bounding.bottom < endSticky;

                    
                    //Sticky inside spot
                    if(isSticky){
                        
                        spot.classList.remove("stuck");
                        spot.classList.add("sticky");
                        spot.style.paddingTop = tabwrapperHeight+"px";
                        tabwrapper.removeAttribute("style");
                        tabwrapper.style.width = spot.offsetWidth+"px";
                    }
                    //Stick to bottom of spot when scrolling out of view
                    else if(isStuck){
                        
                        spot.classList.add("stuck");
                        spot.classList.remove("sticky");
                        tabwrapper.removeAttribute("style");
                        tabwrapper.style.bottom = bottomNavHeight+"px";
                    }
                    else{
                        spot.classList.remove("sticky");
                        spot.classList.remove("stuck");
                        spot.removeAttribute("style");
                        tabwrapper.removeAttribute("style");
                    }
                    
                }

                (function () {
                    
                    function checkboxSelection(spot){
                        var selectors = spot.querySelectorAll(CHECKBOX_CLASS),
                            inner = spot.querySelector(INNER_WRAPPER_CLASS),
                            labels = spot.querySelectorAll(DT_LABELS_CLASS);


                        for (var selector = 0; selector < selectors.length; selector++) {

                            selectors[selector].addEventListener('click', function (e) {
                                
                                var thisSelectorId = e.target.id,
                                    isChecked = e.target.checked;

                                for (var i = 0; i < labels.length; i++) {
                                    if (labels[i].htmlFor != '' && labels[i].htmlFor === thisSelectorId && isChecked) {
                                        var thisTab = labels[i];
                                        thisTab.classList.add(ACTIVE_CLASS);
                                        var isVisible = isInViewportH(thisTab,inner);
                                        if(!isVisible){
                                            var offset = thisTab.getBoundingClientRect().right - inner.getBoundingClientRect().right;
                                            scrollLeft(spot,offset,true);
                                            resetsetVisibility(spot,thisTab);
                                        }
                                    }else{
                                        labels[i].classList.remove(ACTIVE_CLASS);
                                    }
                                }
                                if(isChecked){
                                    for (var s = 0; s < selectors.length; s++) { 
                                        if(selectors[s].id !== thisSelectorId){
                                            selectors[s].checked = false;
                                        }
                                    }
                                }
                            });
                        }
                        
                    }

                    function labelClick(spot){
                    
                        var mobileLabels = spot.querySelectorAll(M_LABELS_CLASS),
                            labels = spot.querySelectorAll(DT_LABELS_CLASS),
                            bottomNav = spot.querySelectorAll(".tab__bottom-nav label");
                        
                        

                        //scroll to label
                        for (var i = 0; i < mobileLabels.length; i++) {
                            mobileLabels[i].addEventListener('click', function (e) {
                                setTimeout(function(){
                                    e.target.scrollIntoView({
                                        behavior: 'smooth' 
                                    });
                                },300)
                            
                            });
                        }

                        
                        //scroll to top of spot if sticky
                        for (var l = 0; l < labels.length; l++) {
                            labels[l].addEventListener('click', function (e) {
                                if(spot.classList.contains("sticky")){
                                    spot.scrollIntoView({
                                        behavior: 'smooth' 
                                    });
                                }
                            });
                        }
                        for (var bl = 0; bl < bottomNav.length; bl++) {
                            bottomNav[bl].addEventListener('click', function (e) {
                                if(spot.classList.contains("sticky")){
                                    spot.scrollIntoView({
                                        behavior: 'smooth' 
                                    });
                                }
                            });
                        }
                    }

                    function navigation(spot){

                        var labels = spot.querySelectorAll(DT_LABELS_CLASS),
                            inner = spot.querySelector(INNER_WRAPPER_CLASS);
                        
                        //desktop timeline button prev
                        spot.querySelector(".tabs__nav--prev").addEventListener("click",
                            function (e) {
                                e.preventDefault();
                                var prev = null;
                                for (var i = 0; i < labels.length; i++) {

                                    if (labels[i].classList.contains(VISIBLE_CLASS)) {
                                        prev = labels[i - 1];
                                        break;
                                    }
                                }
                                if (prev){
                                    var offset = inner.getBoundingClientRect().left - prev.getBoundingClientRect().left;
                                    scrollLeft(spot,offset,false);
                                }
                                
                                if (prev === labels[0]) {
                                    addStateClass(thisSpot, TABS_INIT_CLASS);
                                }
                                resetsetVisibility(spot);
                            });
            
                        //desktop timeline button next
                        spot.querySelector(".tabs__nav--next").addEventListener("click",
                            function (e) {
                                e.preventDefault();
                                var next = null;
                            
                                for (var i = labels.length -1; i > 0; i--) {
                                    
                                    if (labels[i].classList.contains(VISIBLE_CLASS)) {
                                        next = labels[i + 1];
                                        break;
                                    }
                                }
                                if (next){
                                var offset = next.getBoundingClientRect().right - inner.getBoundingClientRect().right;
                                scrollLeft(spot,offset,true);
                                }
                                resetsetVisibility(spot,next);
                            });
                    }

                    

                    function scrollLeft(spot, offset, left) {
                    var inner = spot.querySelector(INNER_WRAPPER_CLASS),
                        scrollAmount = 0;
                    var slideTimer = setInterval(function () {
                        if (left) {
                        inner.scrollLeft += 10;
                        } else {
                        inner.scrollLeft -= 10;
                        }
                        scrollAmount += 10;
                        if (scrollAmount >= offset) {
                        window.clearInterval(slideTimer);
                        }
                    }, 10);
                    }
                    

                    
                    
                    for (var spots = 0; spots < timelineSpots.length; spots++) {
                        var thisSpot = timelineSpots[spots],
                            labelWidth = setLabelsWidth(thisSpot);
                    
                        if (labelWidth > thisSpot.offsetWidth) {
                            thisSpot.classList.add(TAB_NAV_CLASS, TABS_INIT_CLASS);
                        }
                        resetsetVisibility(thisSpot);
                        checkboxSelection(thisSpot);
                        labelClick(thisSpot);
                        navigation(thisSpot);
                    }
                

                })();

                window.addEventListener("resize",
                        function (e) {
                            if (timeout) {
                                window.cancelAnimationFrame(timeout);
                            }
                            timeout = window.requestAnimationFrame(function () {
                                for (var ts = 0; ts < timelineSpots.length; ts++){
                                    var thisSpot = timelineSpots[ts];
                                    scrollable(thisSpot);
                                    stickyTabs(thisSpot);
                                }
                                
                            });
                            
                        });

                window.addEventListener("scroll",
                        function (e) {
                            for (var ts = 0; ts < timelineSpots.length; ts++){
                                var thisSpot = timelineSpots[ts];
                                stickyTabs(thisSpot);
                            }
                        
                            
                        });
            }
        }

    });

})(window, document);